import React, { useState, useRef, useEffect } from 'react';
import ToolBarButton from './toolbar-button';
import {setMessageFilterKey} from '../../actions/application';
import MessageFilters, {getFromKey} from '../../services/message-filters';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';

const MessagesFilter = ({ activeMessageFilter, setMessageFilter }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const filterRef = useRef(null);

  const handleClickOutside = event => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleSelectFilter = key => {
    setMessageFilter(key);
    setOpen(false);
  };

  return (
    <div className="btn-group px-1 pr-4" ref={filterRef}>
      <ToolBarButton
        title={t('topBar.quickFilter')}
        onClick={() => {
          setOpen(!open);
        }}
        icon={(!activeMessageFilter || activeMessageFilter.key === 'ALL') ?
          "lf-icon-filter" :
          "lf-icon-filter-applied"
        }
      />
      {open && (
        <div className={`filter-body ${open ? 'visible' : ''}`}>
          <ul>
            {Object.entries(MessageFilters).map(([key, value]) => {
              if (key === 'USER_SEARCH') {
                return null;
              }
              return (
                <li
                  key={key}
                  className={`${
                    value.key === activeMessageFilter.key ? 'active' : ''
                  }`}
                  onClick={() => handleSelectFilter(value.key)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '5px',
                    paddingLeft: '10px'
                  }}
                >
                  <span>
                    <img
                      src={value.icon}
                      alt={`${key} icon`}
                      className="filter-icon"
                    />
                  </span>{' '}
                  {t(value.i18nKey)}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <style>{`
        .filter-button {
          cursor: pointer;
          color: #001978;
          font-size: 20px;
          margin-right: 10px;
        }

        .filter-button:hover {
          color: #0056b3;
        }

        .filter-body {
          position: absolute;
          z-index: 99999;
          opacity: 0;
          top: 35px;
          right: 0;
          box-sizing: border-box;
          height: 0;
          width: 207px;
          background-color: #ffffff;
          box-shadow: 0px 2px 12px 0px rgba(113, 113, 113, 0.35);
          transition: all ease-in-out 0.2s;
          border-radius: 4px;
          padding: 16px;
        }

        .filter-body.visible {
          opacity: 1;
          height: 220px;
        }

        .filter-body ul {
          width: 100%;
          text-align: left;
          padding: 0;
          font-size: 16px;
        }

        .filter-body ul li {
          height: 47px;
          margin: 0;
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .filter-body ul li.active {
          background-color: #ccd1e4;
        }

        .filter-body ul li i {
          margin: 0 10px 0 20px;
        }

        .filter-body ul li:hover {
          background-color: #f5f5f5;
        }
      `}</style>
    </div>
  );
};

const mapStateToProps = state => ({
  activeMessageFilter: getFromKey(state.application.messageFilterKey)
});

const mapDispatchToProps = dispatch => ({
  setMessageFilter: key => dispatch(setMessageFilterKey(key))
});

const ConnectedMessagesFilter = connect(
  mapStateToProps,
  mapDispatchToProps
)(MessagesFilter);

export default ConnectedMessagesFilter;
